import { Error } from '@clearkit/icons';
import { CKBannerNext, CKBox, CKButton, CKTextFieldNext } from 'clearkit';
import { FC } from 'react';

import AuthLayout, { AuthLayoutHeader } from '~/components/layouts/AuthLayout';

import useStartMagicLinkFlow, {
  buildErrorMessage,
  emailIsValid,
} from '../shared/useStartMagicLinkFlow';

const Login: FC = function() {
  const {
    email,
    setEmail,
    isCreatingMagicLink,
    error,
    createMagicLink,
    formHandler,
  } = useStartMagicLinkFlow();

  return (
    <AuthLayout>
      <>
        <AuthLayoutHeader
          className="sm:w-80"
          description="Enter your email address below, and we'll send you a magic link to sign in."
          header={
            <>
              <span className="font-semibold">Welcome back,&nbsp;</span>
              <span className="font-normal">
                sign in to continue to Clearbit.
              </span>
            </>
          }
        />

        <form onSubmit={formHandler}>
          <CKBox className="w-full p-5 bg-white sm:w-[440px] gap-6">
            {error && (
              <CKBannerNext variant="error">
                <CKBannerNext.IconStatus>
                  <Error />
                </CKBannerNext.IconStatus>
                <CKBannerNext.Header>
                  Whoops, something went wrong.
                </CKBannerNext.Header>
                <CKBannerNext.Body>
                  {buildErrorMessage(error)}
                </CKBannerNext.Body>
              </CKBannerNext>
            )}

            <CKTextFieldNext
              name="email_address"
              onChange={setEmail}
              placeholder="Email address"
              type="email"
              value={email}
            />
            <div>
              <CKButton
                isDisabled={!emailIsValid(email)}
                isLoading={isCreatingMagicLink}
                onClick={createMagicLink}
                variant="bold"
                variantColor="blue"
              >
                Send me a sign in link
              </CKButton>
            </div>
          </CKBox>
        </form>
      </>
    </AuthLayout>
  );
};

export default Login;
